(function($, undefined) {
	
	'use strict';
    // Create a Worldpay client.

    var validateForm = function () {
        var worldpay = ($("html").attr("data-is-dev") === 'true') ? 'T_C_d3215ec3-f9b8-4b06-91da-098b38900abf' : $('#worldpay-cc-form').attr('data-key');
        var button = $('.get-worldPay-token');
        var form = button.closest('form'); //Formulaire de checkout
        var cardInputsCtn = form.find('.card-inputs-inner');
        var ccFieldsId = "#worldpay-cc-form";
        var ccFields = $(ccFieldsId);
        
        if (ccFields.length !== 0) {
            Worldpay.useOwnForm({
                'clientKey': worldpay, //Client id
                'form': form[0],
                'formatCardNumber': false,
                'reusable': false, //Store Card
                'callback': function (status, response) {
                    //Executed on submit of the form
                    document.getElementById('paymentErrors').innerHTML = '';

                    if (form.find('.card-inputs-inner').css('display') === 'block' || button.closest('.create-payment-form').length > 0) {
                        if (response.error) {
                            Worldpay.handleError(form, document.getElementById('paymentErrors'), response.error);
                            $(".validate-form-btn").removeClass("disabled");
                            button.removeClass("disabled");
                        } else {
                            var token = response.token;
                            form.find('input[name=cardToken]').val(token);
                            form[0].submit();
                        }
                    } else {
                        // check payment
                        form[0].submit();
                    }
                }
            });
            // Handle form submission.
            button.on('click', function (event) {
                event.preventDefault();
                if (cardInputsCtn.css('display') === 'block' || button.closest('.create-payment-form').length > 0) {
                    var fn = form.find("input[name = 'firstName']").val();
                    var ln = form.find("input[name = 'lastName']").val();
                    
                    $("#worldpay-cc-form-name").val(fn + " " + ln);
                }
                if (button.closest('form').hasClass('checkout-form')) {
                    var checkout = Fw.component.models().checkout;
                    checkout.continueCheckout(button);
                } else {
                    var tools = Fw.component.models().tools;
                    tools.validateForm(button);
                }
            });
        }
    };

	var worldpayToken = Fw.component.export('worldpayToken', {
		init: validateForm
	});

})(jQuery);